<template>
  <div data-testid="task-selection-table__root">
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="items"
      item-key="_id"
      show-select
      class="bot-selection-table"
      :search="search"
      :items-per-page="15"
      data-testid="task-selection-table__table"
    >
      <template v-slot:top>
        <v-toolbar flat class="toolbar-custom" data-testid="task-selection-table__toolbar">
          <v-toolbar-title class="font-weight-medium primary--text d-flex align-center" data-testid="task-selection-table__title">
            <v-icon left data-testid="task-selection-table__title-icon">mdi-basketball-hoop-outline</v-icon>
            <h5>Task Selection</h5>
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search task..."
            single-line
            hide-details
            class="search-field"
            data-testid="task-selection-table__search-input"
          ></v-text-field>
        </v-toolbar>
      </template>

      <template v-slot:item.location_detail="{ item }">
        <v-chip color="blue-grey lighten-5" data-testid="task-selection-table__location-chip">
          <v-icon left data-testid="task-selection-table__location-icon">mdi-map-marker</v-icon>
          <span data-testid="task-selection-table__location-name">{{ item.location_detail.name }}</span>
        </v-chip>
      </template>

      <template v-slot:no-data>
        <div class="text-center py-4" data-testid="task-selection-table__no-data-panel">
          <v-icon size="60" color="grey lighten-2" data-testid="task-selection-table__no-data-icon">mdi-robot-confused</v-icon>
          <p class="font-size-md grey--text" data-testid="task-selection-table__no-data-msg">No tasks available</p>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "BotSelectionTable",
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "Select", value: "data-table-select" },
        { text: "Reference", value: "ref" },
        { text: "Description", value: "description" },
        { text: "Location", value: "location_detail" },
      ],
    };
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
